import { SPACES_SERVICE } from "@/services/spaces.service.js";

const state = {putSpaceOutput: false, getSpaceByIdOutput: {}, getSpaceByCoachingSessionOutput: {}};

const actions = {
    //Service to save space
    putSpace({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putSpaceRequest');

        SPACES_SERVICE.putSpace(input)
            .then(
                output => {
                    commit('putSpaceSuccess', output);
                },
                error => {
                    commit('putSpaceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get space details
    getSpaceById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getSpaceByIdRequest');

        SPACES_SERVICE.getSpaceById(queryParams)
            .then(
                output => {
                    commit('getSpaceByIdSuccess', output);
                },
                error => {
                    commit('getSpaceByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get space details
    getSpaceByCoachingSession({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getSpaceByCoachingSessionRequest');

        SPACES_SERVICE.getSpaceByCoachingSession(id)
            .then(
                output => {
                    commit('getSpaceByCoachingSessionSuccess', output);
                },
                error => {
                    commit('getSpaceByCoachingSessionFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //putSpace
    putSpaceRequest(state) {
        state.putSpaceOutput = null;
    },
    putSpaceSuccess(state, output) {
        state.putSpaceOutput = true;
    },
    putSpaceFailure(state) {
        state.putSpaceOutput = false;
    },

    //getSpaceById
    getSpaceByIdRequest(state) {
    },
    getSpaceByIdSuccess(state, output) {
        state.getSpaceByIdOutput = output;
    },
    getSpaceByIdFailure(state) {
        state.getSpaceByIdOutput = false;
    },

    //getSpaceByCoachingSession
    getSpaceByCoachingSessionRequest(state) {
    },
    getSpaceByCoachingSessionSuccess(state, output) {
        state.getSpaceByCoachingSessionOutput = output;
    },
    getSpaceByCoachingSessionFailure(state) {
        state.getSpaceByCoachingSessionOutput = false;
    },
};

export const spaces = {
    namespaced: true,
    state,
    actions,
    mutations
};